import DocumentsIconPurple from './DocumentsIconPurple';

export default DocumentsIconPurple;
